module.exports = __webpack_public_path__ + "img/integrity.08488615.svg";